<template>
    <div>
        <div class="bi-com bi-dropdown">
            <b-dropdown
                inputId="select_color"
                class="bi-ddl"
                variant="bi-ddl"
                menu-class="bi-ddl-menu"
                :text="selectedColorTxt || lblDetail.size.placeholder">
                <b-dropdown-item
                    :disabled="true">
                    {{lblDetail.size.placeholder}}
                </b-dropdown-item>
                <b-dropdown-item
                    v-for="(color, index) in arrColor"
                    :key="index" @click="changeColor(color)">
                    {{ locale == 1033 ? color.name_en : color.name }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="bi-com bi-dropdown"
            v-if="haveSize">
            <b-dropdown
                inputId="select_size"
                class="bi-ddl"
                variant="bi-ddl"
                menu-class="bi-ddl-menu"
                :text="selectecSizeTxt || lblDetail.size.placeholder">
                <b-dropdown-item
                    :disabled="true">
                    {{lblDetail.size.placeholder}}
                </b-dropdown-item>
                <b-dropdown-item
                    v-for="(size, index) in arrSize"
                    :key="index" @click="changeSize(size)">
                    {{ locale == 1033 ? size.name_en : size.name }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {array} subcampaign (required) Sub-campaign.
 * Event
 * @event changeColor Change selected item and setup size dropdown.
 * @event changeSize Change selected item.
 * @event updateSelectedCampaignInfo Update information back to parent component.
 */
export default {
    name: 'SubCampaignDropdown',
    props: {
        lbl: Object,
        locale: Number,
        subcampaign: Array,
    },
    data: function () {
        return {
            lblDetail: this.lbl.detail,

            selectedColorTxt: '',
            selectedColor: {},
            selectecSizeTxt: '',
            selectedSize: {},
            haveSize: false,
            arrColor: [],
            arrSize: [],
        };
    },
    mounted: function () {
        this.arrColor = this.subcampaign;
        this.selectedColor = this.subcampaign[0];
        this.selectedColorTxt = this.locale == 1033
                                ? this.selectedColor.name_en
                                : this.selectedColor.name;
        this.changeColor(this.selectedColor);
    },
    methods: {
        //Event
        changeColor: function (color) {
            this.selectedColor = color;
            this.selectedColorTxt = this.locale == 1033
                                        ? color.name_en
                                        : color.name;
            if(color.subitems && color.subitems.length > 0) {
                var size = color.subitems[0];
                if(size.value === 'none') {
                    this.haveSize = false;
                    this.arrSize.length = 0;
                    this.selectedColorTxt = this.locale == 1033
                                            ? color.name_en
                                            : color.name;
                    this.updateSelectedCampaignInfo(color);
                } else {
                    this.haveSize = true;
                    this.arrSize = Util.normalObject(color.subitems);
                    this.selectedSize = size;
                    this.selectecSizeTxt = this.locale == 1033
                                            ? size.name_en
                                            : size.name;
                    this.updateSelectedCampaignInfo(size);
                }
            } else {
                this.haveSize = false;
                this.arrSize.length = 0;
                this.updateSelectedCampaignInfo(color);
            }
        },
        changeSize: function (size) {
            this.selectedSize = size;
            this.selectecSizeTxt = this.locale == 1033
                                            ? size.name_en
                                            : size.name;
            this.updateSelectedCampaignInfo(size);
        },
        updateSelectedCampaignInfo: function (selectedItem) {
            var resultSelectedItem = null;

            if(selectedItem) {
                resultSelectedItem = {
                    campaignId: selectedItem.campaignId,
                    quantity: selectedItem.quantity - selectedItem.itemCountSold,
                    point: selectedItem.point,
                    price: selectedItem.price,
                    originalPrice: selectedItem.originalPrice,
                    discount: selectedItem.discount
                }
            }

            this.$emit('updateSelectedCampaignInfo', resultSelectedItem);
        }
        //End Event
    }
}
</script>
<style lang="scss">

</style>
